export const LABEL_TEMPLATE_SLUGS = ['project', 'spot_maintenance', 'burden', 'everything_else'] as const;

export type LabelTemplateSlug = (typeof LABEL_TEMPLATE_SLUGS)[number];

export interface LabelMarker {
  marker: string;
  description: string;
}

export interface LabelTemplateDepartment {
  code: string;
  name: string;
}

// `slug` is null for a department no template has claimed; it prints Everything Else.
export interface WarehouseLabelDepartment {
  code: string;
  name: string;
  slug: LabelTemplateSlug | null;
}

export interface WarehouseLabelTemplate {
  slug: LabelTemplateSlug;
  name: string;
  body: string;
  departments: LabelTemplateDepartment[];
}

export interface WarehouseLabelConfigPayload {
  templates: WarehouseLabelTemplate[];
  departments: WarehouseLabelDepartment[];
  template_variables: LabelMarker[];
}

// What the page holds while the admin edits, before a save.
export interface TemplateDraft {
  body: string;
  deptCodes: string[];
}

export const warehouseLabelConfigsUrl = '/warehouse/label_configs';

export const warehouseLabelPreviewUrl = '/warehouse/label_preview';

// One PO's real label data. `error` is set (with empty values) when the PO is not found or
// ServMan is down; the request itself still succeeds.
export interface LabelPreviewResult {
  po_number: string | null;
  department: string | null;
  department_code: string | null;
  received: boolean;
  values: Record<string, string>;
  error: string | null;
}

export const labelConfigUrlFor = (slug: LabelTemplateSlug): string => `${warehouseLabelConfigsUrl}/${slug}`;

// Mutations carry the location in the query string rather than the body, keeping the read
// and the write reading it from the same place.
export const withLocation = (url: string, location: string): string =>
  `${url}?location=${encodeURIComponent(location)}`;
